import { render, staticRenderFns } from "./SharingButtons.vue?vue&type=template&id=e6c1dc8a&"
import script from "./SharingButtons.vue?vue&type=script&lang=js&"
export * from "./SharingButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports